import React from "react";
import "../styles/RentTutorialStriemoKey.css";
import { useTranslation } from 'react-i18next';

const RentTutorialCwalk = () => {
  const { t } = useTranslation();
    return (
        <main>
    <section class="app__guide-jp" id="appguide-jp">
        <div class="inner-app">
          
            <h2 class="section-ttl">{t('C+walk How to use')}</h2>

            <ul class="rental-warapper">
              <li class="rental-list">
                <div class="use__img-area">
                  <figure class="use__img"><img src="/images/cwalk/btn.png" alt={t('powerbutton')} /></figure>
                </div>
                <div class="rental__ttl-area ">
                  <h3 class="rental__ttl">{t('1.Please turn on the power of C+walk.')}</h3>
                </div>
                <p class="rental-discription">
                  {t('※Press and hold the power button for 1 second.The power button is located in the center of the C+walkT body.')}
                </p>
              </li>
              <li class="rental-list">
                <div class="use__img-area">
                  <figure class="use__img"><img src="/images/cwalk/key.png" alt={t('key')} /></figure>
                </div>
                <div class="rental__ttl-area">
                  <h3 class="rental__ttl">{t('2.When the power is turned on, hold up the key.')}</h3>
                </div>
                <p class="rental-discription">{t("Please attach the key marked 'C+' to the main unit for a few seconds.")}
                </p>
              </li>
              <li class="rental-list">
                <div class="use__img-area">
                  <figure class="use__img"><img src="/images/cwalk/speed.png" alt={t('speed')} /></figure>
                </div>
                <div class="rental__ttl-area">
                  <h3 class="rental__ttl">{t('3.Please set the speed.')}</h3>
                </div>
                <p class="rental-discription">{t('Can be set from 2~6 km/h.')}</p>
              </li>
              <li class="rental-list">
                <div class="use__img-area">
                  <figure class="use__img"><img src="/images/cwalk/brake.png" alt={t('brake')} /></figure>
                </div>
                <div class="rental__ttl-area">
                  <h3 class="rental__ttl">{t('4.Please pull the brake lever toward you to release the parking brake.')}</h3>
                </div>
                <p class="rental-discription">{t('When you hear a click, you are done!')}</p>
              </li>
              <li class="rental-list">
                <div class="use__img-area">
                  <figure class="use__img"><img src="/images/cwalk/accelerator.png" alt={t('accelerator')} /></figure>
                </div>
                <div class="rental__ttl-area">
                  <h3 class="rental__ttl">{t('5.Press the accelerator lever to advance.Release it to slow down.')}</h3>
                </div>
                <p class="rental-discription">{t('Either lever may be used.')}</p>
              </li>
              <li class="rental-list">
                <div class="use__img-area">
                  <figure class="use__img"><img src="/images/cwalk/brake.png" alt={t('brake')} /></figure>
                </div>
                <div class="rental__ttl-area">
                  <h3 class="rental__ttl">{t('6.If you want to stop the machine completely,pull the brake lever.')}</h3>
                </div>
                <p class="rental-discription"></p>
              </li>
              <li class="rental-list">
                <div class="use__img-area">
                  <figure class="use__img"><img src="/images/cwalk/backbtn.png" alt={t('backbutton')} /></figure>
                </div>
                <div class="rental__ttl-area">
                  <h3 class="rental__ttl">{t('When you want to back up,please press the orange button.')}</h3>
                </div>
                <p class="rental-discription"></p>
              </li>
            </ul>
            <div class="rental__message-area">
              <div class="rental-message">
                {t('This concludes the explanation of how to use it.')}<br/>
                {t('Enjoy the experience!')}
              </div>
            </div>
            <div class="cp_arrows">
                <div class="cp_arrow"></div>
                <div class="cp_arrow"></div>
              </div>
      
        </div>
      </section>
    </main>
    );
};

export default RentTutorialCwalk;
